import React from 'react';
import Image from 'react-bootstrap/Image';
// import ClockImage from '../../icons/clock';
import PhoneImage from '../../icons/phone';
import LocationImage from '../../icons/place';
import LetterImage from '../../icons/letter';

export function UserInfoCol({ user }) {
    const { username, address, email, image, telephone } = user;
    const phoneNumber = telephone ? telephone : '';
    const formattedPhoneNumber = phoneNumber.replace(/(\d{2})(\d{2})(\d{2})(\d{2})/, "$1 $2 $3 $4");
    //console.log(user);

    return(
        <div className="d-flex flex-column justify-content-center align-items-center">
            <div className="profile-image-container col-11 m-auto">
                <Image src={`${image.url}`} fluid alt="Your-profile-picture" style={{ borderRadius: '20px' }}/>
            </div>
            <div className="d-flex flex-column mt-3 col-8 m-auto">
                <p className="user-name">{username}</p>
                <div className="d-flex mt-5">
                    <div className="col-1 me-3 "><LocationImage /></div>
                    <div className="">
                        <p className="me-3 user-info-text">{address ? address.street : ''}</p>
                        <p className="user-info-text">{address ? address.zip : ''}, {address ? address.city : ''}</p>
                    </div>
                </div>
                <div className="d-flex mt-2 m-auto">
                    <div className="col-1 me-3"><PhoneImage /></div>
                    <p className="user-info-text">{formattedPhoneNumber ? formattedPhoneNumber : ''}</p>
                </div>
                {/* <div className="d-flex mt-2">
                    <div className="col-1 me-3"><ClockImage /></div>
                    <p className="user-info-text">Man-Fre / {opening_hours.monday_friday.start} - {opening_hours.monday_friday.end}</p>
                </div> */}
                <div className="d-flex mt-2">
                    <div className="col-1 me-3"><LetterImage /></div>
                    <p className="user-info-text">{email}</p>
                </div>
            </div>
        </div>
    )
}

export default UserInfoCol;